import { render, staticRenderFns } from "./ImageAudioVideo.vue?vue&type=template&id=1315d1c6&scoped=true&"
import script from "./ImageAudioVideo.vue?vue&type=script&lang=js&"
export * from "./ImageAudioVideo.vue?vue&type=script&lang=js&"
import style0 from "./ImageAudioVideo.vue?vue&type=style&index=0&id=1315d1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1315d1c6",
  null
  
)

export default component.exports